import { DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { AntdSpin, Button } from '@ui/components';
import { ContactSupport } from './ContactSupport';

type EndOfResultsProps = {
  enabledAnalytics: boolean;
  hasNextPage: boolean;
  isFetchingMore: boolean;
  onLoadMore: () => void;
  searchString?: string;
};

export const EndOfResults = ({
  enabledAnalytics,
  hasNextPage,
  isFetchingMore,
  searchString = '',
  onLoadMore,
}: EndOfResultsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-6 pb-6">
      {hasNextPage && (
        <div className="flex flex-col items-center gap-2 mb-6">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-base-300 to-transparent mb-2" />
          <Button
            type="default"
            size="large"
            onClick={onLoadMore}
            disabled={isFetchingMore}
            className="min-w-[220px] border-primary-400 text-primary-600 hover:border-primary-600 hover:text-primary-700"
            icon={isFetchingMore ? <AntdSpin size="small" /> : <DownOutlined />}
          >
            {t('sign_up_v2_page.disease_form.disease_search_v2.end_of_results.load_more')}
          </Button>
        </div>
      )}

      <ContactSupport
        key={searchString}
        enabledAnalytics={enabledAnalytics}
        searchString={searchString}
        title={t('sign_up_v2_page.disease_form.disease_search_v2.contact.title_end_of_results')}
      />
    </div>
  );
};
